import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { AniFormValues } from '../../modals/AdditionalNamedInsuredModal';
import { AdditionalNamedInsuredModalConfig } from '../../modals/AdditionalNamedInsuredModal';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { ContextTypes } from '../manager';

export const AdditionalNamedInsured = (props: AmendatoryLineItemProps) => {
  const handleAddNamedInsured = (formValues: AniFormValues) => {
    const _ani = formatAniForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          items: { values: _ani },
        },
      },
    });
  };

  if (props.contextType !== ContextTypes.ENDORSEMENTS) {
    return null;
  }

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(AdditionalNamedInsuredModalConfig, {
          data: {
            onSubmit: handleAddNamedInsured,
            context: props.contextType ?? ContextTypes.ENDORSEMENTS,
            aniValues: getDefaultAniFields(
              props.value?.props?.items?.values as AniValue,
              props.rules?.items?.options as string[]
            ),
            options: props.rules?.items?.options ?? [],
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.items?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default AdditionalNamedInsured;

export function getDefaultAniFields(values: AniValue, options: string[]) {
  if (!values) {
    return options;
  }

  return values.map((value) => value.value);
}

export function formatAniForState(formValues: AniFormValues) {
  return formValues.ani.map((ani) => ({
    value: ani,
  }));
}

export type AniValue = { value: string }[];
